module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/babel-loader/lib/index.js!../../node_modules/jsxstyle-webpack-plugin/lib/loader.js??ref--4-1!./index.js"));
	});
}